// extracted by mini-css-extract-plugin
export var gridContainer = "styles-module--gridContainer--fukMb";
export var asideInfoContainer = "styles-module--asideInfoContainer--AzeEL";
export var asideNavContainer = "styles-module--asideNavContainer--WDOXv";
export var heroContainer = "styles-module--heroContainer--LUxej";
export var contentContainer = "styles-module--contentContainer--R1DTQ";